import React from 'react';
import DetailML from './DetailML';

export default (props) => <DetailML {...props} />;
